import { module } from 'angular';
import App from '../../../app';

class SCR0602Controller {
	
	constructor ($scope, $state, $uibModalInstance, $timeout, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		this.msgs = this.data.msgs;
		
		this.argNm = 'param';
		
		this.initWindow(840, 720);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initGridOption();
			this.getMappingFunctionList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageFunction'));
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(5);
	}
	
	initGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "mappingFuncNm"}, {fieldName: "guideDesc"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "mappingFuncNm", fieldName: "mappingFuncNm", header : { text: this.text.mappingFuncNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "guideDesc", fieldName: "guideDesc", header : { text: this.text.guideDesc }, width: 100, styles: { textWrap: 'ellipse' } }
		]);
		
		this.gridView.onDataCellClicked = (grid, cell) => {
			let row = grid.getValues(cell.itemIndex);
			
			this.getMappingFunction(row.mappingFuncNm);
		};
		
		this.detailGridView = new RealGridJS.GridView('detail-grid');
		this.detailDataProvider = new RealGridJS.LocalDataProvider();
		this.detailGridView.setDataSource(this.detailDataProvider);		
		this.gridService.setDefaultSetting(this.detailGridView);
		this.detailGridView.setCheckBar({visible: false});
		this.detailGridView.setSelectOptions({style: 'block'});
		this.detailGridView.setEditOptions({editable: true});
		this.detailGridView.setDisplayOptions({fitStyle: 'evenFill', rowHeight: 24}); 
		this.detailGridView.setSortingOptions({enabled: false});
		
		this.detailDataProvider.setFields([]);
		this.detailGridView.setColumns([]);
		
		this.detailGridView.onDataCellClicked = (grid, cell) => {
			const fieldIndex = cell.fieldIndex + 1;
			const $forms = $(`#method${fieldIndex}`);
			const method = $forms[0].value;
			
			let column = grid.columnByName('column' + fieldIndex);
			
			if(method == 'msg'){
				column.editor = {type: 'dropdown', domainOnly: true, textReadOnly: true, dropDownWhenClick: true};
				column.labels = this.msgs.map((v, i) => {
					return '[' + (i+1) + '] ' + v;
				});
				column.values = this.msgs;
			}else{
				column.editor = {type: 'text'};
				column.labels = null;
				column.values = null;
			}
			
			grid.setColumn(column);
			grid.commit();
		};
	}
	
	getMappingFunctionList(goToFirst = false) {
		const { pageNumber, pageSize } = this.getPageInfo();
		let url = `/mappingfuncs?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.mappingfuncbsOutList);
		});
	}
	
	getMappingFunction(funcNm){
		this.httpService.get(`/mappingfuncs/${funcNm}`).then(data => {
			this.mappingFuntion = data;
			
			if(this.mappingFuntion.argsCnt > 0) {
				$('#detailGridWrap').show();
			}else{
				$('#detailGridWrap').hide();
			}
			
			this.changeArgsColum();
		});
	}
	
	changeArgsColum(){
		const length = this.mappingFuntion ? this.mappingFuntion.argsCnt : 0;

		let fieldList = [];
		let columnList = [];
		let $selectList = [];
		let $detailSelect = $('#detail-select');
		let selectWidth = $detailSelect.width() / length;
		
		for(let i = 1 ; i <= length; i++){
			fieldList.push({fieldName: this.argNm + i});
			
			columnList.push({ 
				name: 'column' + i, fieldName: this.argNm + i, header : { text: this.text.arg + '#' + i } , 
				width: 100, styles: { textAlignment: 'center' },
				editor: { type: 'dropdown', domainOnly: true, textReadOnly: true, dropDownWhenClick: true },
				values: this.msgs,
				labels: this.msgs.map((v, i) => {
					return '[' + (i+1) + '] ' + v;
				}),
				lookupDisplay: true
			});

			let left = (i - 1) * selectWidth + (selectWidth / 2 + 20);
			
			$selectList.push(`
				<select class="bw-input ipt-select" 
					style="width:80px; height : 20px; font-size : 10px !important; z-index: 10; position: absolute; top: 24px; left: ${left}px;" 
					id = "method${i}">
					<option label="${this.text.enFieldNm}" value="msg">${this.text.enFieldNm}</option>
					<option label="${this.text.int}" value="text">${this.text.int}</option>
				</select>`);
		}
		
		this.detailDataProvider.setFields(fieldList);
		this.detailGridView.setColumns(columnList);
		this.detailDataProvider.setRows([{}]);
		this.detailGridView.resetSize(); 
		$detailSelect.html($selectList);
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getMappingFunctionList(true);
	}
	
	search(){
		this.getMappingFunctionList(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getMappingFunctionList(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				const result = this._changeParams();
				this.$uibModalInstance.close(result);
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
		this.detailGridView.destroy();
		this.detailDataProvider.destroy();
	}
	
	_changeParams(){
		let result = "";
		let funcNm = this.mappingFuntion.mappingFuncNm;
		const startIndex = funcNm.indexOf('(');
		
		if(this.mappingFuntion.argsCnt === 0) return funcNm;
		
		this.detailGridView.commit();
		
		if(startIndex === -1){
			const argsRow = this.detailDataProvider.getJsonRows()[0];
			const argsCnt = this.mappingFuntion.argsCnt;
			
			Object.keys(argsRow).map(v => {
				if(!argsRow[v]) delete argsRow[v];
			});
			
			const params = argsRow;
				
			result = `${funcNm}(`;
			
			for(let i = 1; i <= argsCnt ; i++){
				const param = params[`${this.argNm}${i}`];
				if(!_.isEmpty(param)) result += `${param},`;
			}
			
			if(Object.keys(params).length > 0) result = result.slice(0,-1);
			result += ')';
		} else {
			result = funcNm.slice(0, startIndex + 1);
			
			const paramCount = (funcNm.match(/,/g) || []).length + 1;
			const argsRow = this.detailDataProvider.getJsonRows()[0];

			Object.keys(argsRow).map(v => {
				if(!argsRow[v]) delete argsRow[v];
			});
			
			const params = argsRow;
			
			for(let i = 1; i <= paramCount ; i++){
				const param = params[`${this.argNm}${i}`];
				if(!_.isEmpty(param)) result += `${param},`;
			}
			
			if(Object.keys(params).length > 0) result = result.slice(0,-1);
			if(funcNm.indexOf(')') !== -1) result += ')';
		}
		
		return result;
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
	
	commitChange() {
		this.detailGridView.commit();
	}
}

module(App.name).controller('SCR0602Controller', SCR0602Controller);


// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0602/SCR0602.controller.js